import { api, get, post } from '../api.js';

export async function getCache(idCache, idZec = null, authToken = "") {
    if (idZec) {
        return get(`/${idZec}/Cache/${idCache}`, true, authToken);
    }
    return api.get(`Cache/${idCache}`);
}

export function sauvegarderCache(cache, idZec = null, authToken = "") {
    if (idZec) {
        return post(`/${idZec}/Cache/sauvegarder`, JSON.stringify(cache), false, authToken);
    }
    return api.post('Cache/sauvegarder', JSON.stringify(cache), false);
}
